export const sxStyle = {
  containerFooter: {
    py: 0,
  },
};
